import { Pedido } from '@/models/pedido'

interface ExclusaoVeiculoForm{
  currentStep: number;
  isLoading: boolean;
  data: Pedido;
  documentos: Array<any>;
  error: any;
}

export const initialStateExclusaoVeiculoForm: ExclusaoVeiculoForm = {
  currentStep: 1,
  isLoading: false,
  data: null,
  documentos: [],
  error: null,
}

export default {
  form: initialStateExclusaoVeiculoForm
}
